var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagonSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 142,
    viewBox: "0 0 130 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_602_10227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0525 129.724C59.466 131.114 62.2036 131.846 64.9904 131.846C67.7772 131.846 70.5149 131.114 72.9284 129.724L112.062 107.194C114.475 105.804 116.479 103.806 117.873 101.398C119.266 98.9913 120 96.2608 120 93.4812L120 48.3641C120 45.5845 119.266 42.854 117.873 40.4469C116.479 38.0397 114.475 36.0408 112.062 34.6511L72.9284 12.1212C70.5149 10.7313 67.7772 9.99957 64.9904 9.99957C62.2036 9.99957 59.466 10.7313 57.0525 12.1212L17.938 34.6511C15.5247 36.0409 13.5207 38.0397 12.1273 40.4469C10.7339 42.854 10.0002 45.5845 9.99999 48.3641L10 93.4812C10.0002 96.2608 10.7339 98.9913 12.1273 101.398C13.5207 103.806 15.5247 105.804 17.938 107.194L57.0525 129.724Z",
    fill: "#2468FF",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6789 129.291L72.6789 129.291L111.813 106.761C111.813 106.761 111.813 106.761 111.813 106.761C114.15 105.415 116.091 103.479 117.44 101.148C118.789 98.8169 119.5 96.1727 119.5 93.4811L119.5 48.3641C119.5 45.6725 118.789 43.0284 117.44 40.6973C116.091 38.3663 114.15 36.4304 111.813 35.0843L72.6789 12.5545L72.6788 12.5545C70.3413 11.2083 67.6897 10.4996 64.9904 10.4996C62.2911 10.4996 59.6396 11.2083 57.3021 12.5545L18.1875 35.0843L17.938 34.6511L18.1875 35.0844C15.8502 36.4304 13.9094 38.3663 12.56 40.6974C11.2107 43.0284 10.5002 45.6726 10.5 48.3641L10.5 93.4812C10.5002 96.1727 11.2107 98.8169 12.5601 101.148C13.9094 103.479 15.8502 105.415 18.1875 106.761L18.1875 106.761L57.3021 129.291C57.3021 129.291 57.3021 129.291 57.3021 129.291C59.6396 130.637 62.2911 131.346 64.9904 131.346C67.6897 131.346 70.3414 130.637 72.6789 129.291Z",
    stroke: "#2468FF",
    strokeOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_602_10227",
    x: 0,
    y: 0,
    width: 130,
    height: 141.846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_602_10227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_602_10227",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonSelected);
export default __webpack_public_path__ + "static/media/hexagon-selected.90a0371fe36a9141723751990af9885a.svg";
export { ForwardRef as ReactComponent };